import * as Sentry from '@sentry/gatsby';

import { config } from './config';

Sentry.init(config);
